import ContractManagementList from './ContractManagementList';

export default ContractManagementList;
